import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import WixAccountForm from '../components/WixAccountForm';
import { clearWorkspaceScopedSelections, setCurrentOrgId, setRole } from '../utils/permissions';

export default function WixProductAccount({ onAuthenticated }) {
  const { t, i18n } = useTranslation();
  const [authMode, setAuthMode] = useState('register');
  const [firstName, setFirstName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [emailExists, setEmailExists] = useState(false);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function authenticate(event, register) {
    event.preventDefault();
    if (loading) return;
    setErr(''); setEmailExists(false);
    if (register && !firstName.trim()) { setErr(t('wxo_err_first_name')); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail.trim())) { setErr(t('wxo_err_email')); return; }
    if (register && pw.length < 8) { setErr(t('wxo_err_password_short')); return; }
    if (register && pw !== pw2) { setErr(t('wxo_err_password_match')); return; }
    setLoading(true);
    try {
      // Installation ownership is linked separately with its scoped grant.
      // Never pass a multi-app instance into the original app's auth shortcut.
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${register ? 'register' : 'login'}/`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: userEmail.trim(), password: pw,
          ...(register ? { given_name: firstName.trim(), send_email: true, language: i18n.resolvedLanguage || i18n.language } : {}) }),
      });
      const data = await response.json();
      if (!response.ok) {
        if (register && data.detail === 'Email already registered') { setEmailExists(true); return; }
        throw new Error(typeof data.detail === 'string' ? data.detail : t(register ? 'wxo_err_create_account' : 'wxo_err_invalid_login'));
      }
      if (!data.token || !data.user_id) throw new Error(t('wxo_err_generic'));
      clearWorkspaceScopedSelections();
      localStorage.setItem('token', data.token);
      localStorage.setItem('user_id', String(data.user_id));
      localStorage.setItem('first_name', data.first_name || firstName.trim());
      setCurrentOrgId(data.current_org_id);
      setRole(data.role, data.owner_user_id);
      if (data.timezone) localStorage.setItem('timezone', data.timezone);
      if (data.date_format) localStorage.setItem('date_format', data.date_format);
      await onAuthenticated();
    } catch (error) { setErr(error.message || t('wxo_err_generic')); }
    finally { setLoading(false); }
  }

  return <WixAccountForm {...{ authMode, setAuthMode, firstName, setFirstName, userEmail, setUserEmail,
    pw, setPw, pw2, setPw2, emailExists, setEmailExists, err, setErr, loading }}
    handleRegister={event => authenticate(event, true)} handleLogin={event => authenticate(event, false)} />;
}
